import { getPostSecuredStrategies } from '../../Services/Api';
import { Post, Source } from '../Types/Posts';

export const getSecuredStrategies = async (postId: string | number, setting: string) => {
  const response = await getPostSecuredStrategies(postId, setting);

  return response?.data?.data;
};

const validateSecuredStrategies = async (
  post: Post | Source,
  setting: string,
  callback: any = () => {},
  onError?: any,
) => {
  const strategies = await getSecuredStrategies(post.id, setting);
  const { secured_strategies_validated } = strategies;

  if (secured_strategies_validated) {
    await callback(strategies.secured_strategies_statuses);
  } else if (onError) {
    onError(strategies.secured_strategies_statuses);
  } else {
    const currentPath = window.location.pathname + window.location.search;

    // NOTE: Hotfix, while we work on passing navigate() to this function
    window.location = `/${window.spaceSlug}/posts/${post.slug}/secured-strategies?redirect_to=${currentPath}&setting=${setting}`;
  }
};

export const validateCanParticipate = (
  post: Post | Source,
  callback: any = () => {},
  onError?: any,
) => {
  return validateSecuredStrategies(post, 'secured_strategies_contribute', callback, onError);
};

export const validateCanVote = (post: Post | Source, callback: any = () => {}, onError?: any) => {
  return validateSecuredStrategies(post, 'secured_strategies_vote', callback, onError);
};

export const validateCanComment = (
  post: Post | Source,
  callback: any = () => {},
  onError?: any,
) => {
  return validateSecuredStrategies(post, 'secured_strategies_comment', callback, onError);
};

export default {
  getSecuredStrategies,
  validateCanParticipate,
};
